import get from 'lodash/get';

import { MOST_EXPENSIVE_ITEM_COLOR_MAP } from '@cast/constants';
import { TopMostExpensiveGroup } from 'types/top-items';

import { groupNLargestBy } from './groupNLargestBy';

type FilterMostExpensiveItemsOptions<T extends Array<any>> = {
  /** Default: 5 */
  count?: number;
  mapFn?: (item: T[number]) => { id: string; name: string };
};

export const filterMostExpensiveItems = <T>(
  data: T[],
  criterion: string | ((item: T) => number),
  options: FilterMostExpensiveItemsOptions<T[]> = {}
): TopMostExpensiveGroup[] => {
  const { count = 5, mapFn } = options;

  return groupNLargestBy(data, count, criterion).map((d, index) => {
    let cost: number;
    if (typeof criterion === 'string') {
      cost = get(d, criterion);
    } else {
      cost = criterion(d);
    }

    return {
      ...(mapFn
        ? mapFn(d)
        : { id: (d as any)?.id ?? '', name: (d as any)?.name ?? '' }),
      cost,
      color: MOST_EXPENSIVE_ITEM_COLOR_MAP.colorByUsageRank[index],
    };
  });
};
